import { EmblaOptionsType } from "embla-carousel";
import orgnaigrame from "../../images/ORGA_AQUAVESC_2026.png";
import "../../style/carouselPerView.css";
import { FrameThree } from "../Frame";

import olivierImg from "../../images/Bureau Aquavesc/AQ_1eVP_Oliver_Berthet.jpg";
import catherineImg from "../../images/Bureau Aquavesc/AQ_2eVP_Catherine_Bastoni.jpg";
import philippeImg from "../../images/Bureau Aquavesc/AQ_3eVP_Philippe_Benassaya.jpg";
import pierreImg from "../../images/Bureau Aquavesc/AQ_4eVP_Pierre_Chevalier.jpg";
import jeanBaptisteImg from "../../images/Bureau Aquavesc/AQ_5eVP_Jean-Baptiste Hamonic.jpg";
import othmanImg from "../../images/Bureau Aquavesc/AQ_6eVP_Othman_Nasrou.jpg";
import lucImg from "../../images/Bureau Aquavesc/AQ_Assesseur_Luc_Wattelle.jpg";
import marcImg from "../../images/Bureau Aquavesc/AQ_Assesseur_Marc_Richard.jpg";
import erikImg from "../../images/Bureau Aquavesc/AQ_President_Erik_Linquier.jpg";

import Aos from "aos";
import { useEffect, useState } from "react";
import { FaChevronDown, FaChevronUp, FaUsers } from "react-icons/fa";
import { Avatar, AvatarImage } from "../ui/avatar";
import { Button } from "../ui/button";

const teamData = [
  {
    id: "1",
    name: "Olivier Berthet",
    post: "1er Vice-président",
    desc: "Finance",
    avatar: olivierImg,
  },
  {
    id: "2",
    name: "Catherine Bastoni",
    post: "2e Vice-présidente",
    desc: "Suivi des Délégations de Service Public (DSP)",
    avatar: catherineImg,
  },
  {
    id: "3",
    name: "Philippe Benassaya",
    post: "3e Vice-président",
    desc: "Travaux",
    avatar: philippeImg,
  },
  {
    id: "4",
    name: "Pierre Chevalier",
    post: "4e Vice-président",
    desc: "Communication et administration générale",
    avatar: pierreImg,
  },
  {
    id: "5",
    name: "Jean-Baptiste Hamonic",
    post: "5e Vice-président",
    desc: "Urbanisme, Valorisation du patrimoine foncier et Protection de la ressource",
    avatar: jeanBaptisteImg,
  },
  {
    id: "6",
    name: "Othman Nasrou",
    post: "6e Vice-président",
    desc: "Marchés publics",
    avatar: othmanImg,
  },
  {
    id: "7",
    name: "Luc Wattelle",
    post: "Assesseur",
    desc: "",
    avatar: lucImg,
  },
  {
    id: "8",
    name: "Marc Richard",
    post: "Assesseur",
    desc: "",
    avatar: marcImg,
  },
];

const SectionHeading = ({ title }: { title: string }) => (
  <div className="flex flex-col items-center mb-10 text-center">
    <h2 className="[font-family:'Roboto',Helvetica] text-[26px] font-bold text-[#242424]">
      {title}
    </h2>
    <div className="w-16 h-1 mt-3 rounded-full bg-primary" />
  </div>
);

const OPTIONS: EmblaOptionsType = { align: "start", loop: true };
function TeamSection() {
  useEffect(() => {
    Aos.init();
  }, []);

  const [showImage, setShowImage] = useState(false);

  const handleIconClick = () => {
    setShowImage(!showImage);
  };

  return (
    <>
      <div className="container mx-auto px-6 pb-20 sm:px-10 lg:px-24">
        <SectionHeading title="Bureau" />

        <div className="flex flex-col items-center justify-center gap-6 p-8 md:p-10 rounded-2xl bg-gradient-to-br from-primary to-[#027BC0] shadow-lg sm:flex-row sm:justify-start">
          <Avatar className="w-[150px] h-[150px] ring-4 ring-white/40">
            <AvatarImage
              alt="Erik Linquier"
              src={erikImg}
              className="object-cover object-top"
            />
          </Avatar>
          <div className="text-center sm:text-left">
            <p className="text-2xl font-bold text-white">Erik Linquier</p>
            <p className="mt-1 text-white/90">Président</p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 mt-8 sm:grid-cols-3 lg:grid-cols-4">
          {teamData.map((item) => (
            <FrameThree
              key={item.id}
              avatar={item.avatar}
              text={item.name}
              text1={item.post}
              desc={item.desc}
            />
          ))}
        </div>

        <div className="mt-20">
          <SectionHeading title="Notre Équipe" />

          <div className="flex justify-center">
            <Button onClick={handleIconClick} size="lg">
              <FaUsers className="w-5 h-5 mr-2" />
              {showImage
                ? "Masquer l'organigramme"
                : "Afficher l'organigramme"}
              {showImage ? (
                <FaChevronUp className="w-3 h-3 ml-2" />
              ) : (
                <FaChevronDown className="w-3 h-3 ml-2" />
              )}
            </Button>
          </div>

          {showImage && (
            <div className="flex justify-center mt-10">
              <img
                src={orgnaigrame}
                alt="Organigramme AQUAVESC"
                className="max-w-full p-3 bg-white shadow-lg rounded-2xl"
                data-aos="zoom-in-up"
                data-aos-duration="1000"
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default TeamSection;
